import styled from "@emotion/styled";
import { m } from "framer-motion";
import { padding } from "polished";
import * as React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";

export const LeadFormLeftContentWrapper = styled(m.div)(({ theme }) => ({
  background: "linear-gradient(136.4deg, #F5F1EE 5.96%, #F8D9C7 90.41%)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  flex: "37.5%",
  height: "100vh",
  display: "flex",
  ...padding(
    0,
    theme.spacing.MED.sml,
    theme.spacing.MED.xlrg,
    theme.spacing.MED.sml,
  ),
  [theme.breakpoints.MED]: {
    display: "none",
  },
}));

export const LeadFormLeftContentContainer = styled.div(({ theme }) => ({
  marginTop: theme.navHeights.desktop,
  width: "100%",
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.phone]: {
    marginTop: theme.navHeights.mobile,
  },
}));

export const LeadFormRightContentContainer = styled(Container)({
  flex: "62.5%",
  height: "100vh",
  position: "relative",
});

export const BrexFlagBlackBG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    style={{
      enableBackground: "new 0 0 1024 1024",
      borderRadius: "6px",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      style={{
        fill: "#212121",
      }}
      d="M.1 0H1024v1023.9H.1z"
    />
    <path
      d="M697.1 244.2c-33.9 0-65.8 15.7-86 42.8l-21 27.8c-8.5 11.3-22.2 18.2-36.3 18.2H180v446.8h146.5c33.9 0 65.8-15.7 86-42.8l21-27.8c8.5-11.3 22.2-18.2 36.3-18.2H844V244.2H697.1zm30.6 330.6H571.1c-33.9 0-65.8 15.7-86 42.8l-21 27.8c-8.5 11.3-22.2 18.2-36.3 18.2H296.3V449.2h156.6c33.9 0 65.8-15.7 86-42.8l21-27.8c8.5-11.3 22.2-18.2 36.3-18.2h132l-.5 214.4z"
      style={{
        fill: "#f5f0f0",
      }}
    />
  </svg>
);
